import _, { omit, uniq } from 'lodash'
import { SMART_FILTERS } from '@edulastic/constants/const/filters'
import { setFilterInSession } from '../../../../common/utils/helpers'

export const LIBRARY_SCOPE_FILTERS = [
  SMART_FILTERS.ENTIRE_LIBRARY,
  SMART_FILTERS.CERTIFIED_CONTENT,
  SMART_FILTERS.DISTRICT_CERTIFIED_LIBRARY,
]

export const isLibraryScopeFilter = (filter) =>
  LIBRARY_SCOPE_FILTERS.includes(filter)

export const FilterTypes = {
  broad: 'broad',
  narrow: 'narrow',
}

const commonCoreCurriculumToId = {
  Mathematics: 212,
  ELA: 213,
  Science: 215,
  'Social Studies': 236,
}

export const getFilterType = (filter) => {
  if (
    filter.standardIds?.length ||
    filter.questionType ||
    filter.depthOfKnowledge ||
    filter.authorDifficulty ||
    filter.collections?.length ||
    filter.status ||
    filter.tags?.length ||
    filter.authoredByIds?.length ||
    filter.createdAt ||
    filter.type ||
    (filter.curriculumId &&
      !Object.values(commonCoreCurriculumToId).includes(filter.curriculumId))
  ) {
    return FilterTypes.narrow
  }

  return FilterTypes.broad
}

/**
 * Normalizes search tags by removing duplicates and truncating to 64 characters
 * Used across ItemList and AddItems components for consistent search tag processing
 * @param {Array<string>} tags - Array of search tag strings
 * @returns {Array<string>} Normalized array of unique tags (max 64 chars each)
 */
export const normalizeSearchTags = (tags) => {
  return uniq(tags.map((t) => (t.length > 64 ? t.slice(0, 65) : t)))
}

export const getMatchingFilterObjects = ({
  filterMenuItems,
  filterPath,
  filter,
}) => {
  const childFilterMenuItems = _.flatten(
    filterMenuItems.map((v) => v.children || [])
  )
  const allFilterMenuItems = [...childFilterMenuItems, ...filterMenuItems]
  const getMatchingObj = allFilterMenuItems.filter(
    (item) => item.path === filterPath || item.filter === filter
  )
  return getMatchingObj
}

export const persistSearchFilterToSession = ({
  searchFilter,
  userId,
  districtId,
  sessionFilterKeys,
}) => {
  if (isLibraryScopeFilter(searchFilter.filter)) {
    const secondary = omit(searchFilter, ['filter', 'folderId'])
    LIBRARY_SCOPE_FILTERS.forEach((scopeFilter) => {
      setFilterInSession({
        key: sessionFilterKeys[`SEARCH_FILTER_${scopeFilter}`],
        filter: {
          ...secondary,
          filter: scopeFilter,
          status:
            scopeFilter === SMART_FILTERS.ENTIRE_LIBRARY
              ? ''
              : searchFilter.status,
        },
        userId,
        districtId,
      })
    })
  } else {
    setFilterInSession({
      key: sessionFilterKeys[`SEARCH_FILTER_${searchFilter.filter}`],
      filter: searchFilter,
      userId,
      districtId,
    })
  }
}
